import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import DataGrid, { Button, Column, DataGridRef, Editing, FilterRow, Form, Format, Lookup, Pager, Paging, Popup, Item as ToolbarItem, Toolbar } from "devextreme-react/data-grid";
import { EmptyItem, GroupItem, Item } from "devextreme-react/form";
import { dataGridErrorHandling, showError } from '../../utils/errorHandling';
import { useAssistitiContattiDataSource } from '../../datasources/AssistitiContattiDataSource';
import { useScreenSize } from '../../utils/media-query';
import { useTenantsContattiDataSource } from '../../datasources/TenantsContattiDataSource';

type Props = {
  tenantId: string;
  onchanged?: () => void;
}

export type TenantEditContattiPanelHandle = {
}

const TenantEditContattiPanel: React.ForwardRefRenderFunction<TenantEditContattiPanelHandle, Props> = (props, ref) => {
  const dataSource = useTenantsContattiDataSource(props.tenantId);
  const gridRef = useRef<DataGridRef>(null);

  return (
    <React.Fragment>
      <DataGrid
        dataSource={dataSource}
        ref={gridRef}
        onDataErrorOccurred={dataGridErrorHandling}
        onRowUpdating={e => e.newData = Object.assign({}, e.oldData, e.newData)}
      >
        <Editing
          mode="popup"
          allowUpdating={true}
          allowAdding={true}
          allowDeleting={true}>
          <Popup title="Contatto" showTitle={true} />
          <Form colCount={3}>
            <Item dataField="ruolo" editorType='dxTextBox' colSpan={3} isRequired={true} />
            <Item dataField="nome" editorType='dxTextBox' />
            <Item dataField="cognome" editorType='dxTextBox' />
            <EmptyItem />
            <Item dataField="email" editorType='dxTextBox' editorOptions={{ mode: "email" }} />
            <Item dataField="telefono" editorType='dxTextBox' />
            <Item dataField="cellulare" editorType='dxTextBox' />
            <Item dataField="note" editorType='dxTextArea' colSpan={3} />
          </Form>
        </Editing>
        <Column type='buttons' alignment='left' />
        <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
        <Column dataField={'ruolo'} caption={'Ruolo'} hidingPriority={4} />
        <Column dataField={'nome'} caption={'Nome'} />
        <Column dataField={'cognome'} caption={'Cognome'} />
        <Column dataField={'email'} caption={'Email'} hidingPriority={3} />
        <Column dataField={'telefono'} caption={'Telefono'} hidingPriority={2} />
        <Column dataField={'cellulare'} caption={'Cellulare'} hidingPriority={1} />
        <Column dataField={'note'} caption={'Note'} hidingPriority={0} />
        <Toolbar>
          <ToolbarItem location="after" name="addRowButton" >

          </ToolbarItem>
          <ToolbarItem
            location="center"
            name="caption"
            render={() => (
              <div style={{ fontSize: 14, fontWeight: 'bold' }}>
                Contatti
              </div>
            )}
          />

        </Toolbar>
      </DataGrid>
    </React.Fragment>
  );
}

export default React.forwardRef(TenantEditContattiPanel);